const computed = require('../computed/account/orders');
const _ = require('lodash');
const { thenWithErrorHandling } = require('../../helpers/errorHandler');
const { saveAs } = require('file-saver');
const progressBarHelper = require('../../helpers/progress-bar');
const ordersComputedActions = require('../../actions/computed/account/orders');
const currentOrderActions = require('../../actions/account/current-order');
const debouncedSetName = _.debounce(setName, 1000);
const debouncedUpdateOrderAmount = _.debounce(updateOrderAmount, 1000);

function setName (args, state, output, { locator, context }) {
    const API = locator.resolve('api');
    const orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
    const name = state.get(['account', 'orders', 'currentOrder', 'name']);

    const request = API.setName(context, locator, { name, orderId });

    request.then((response) => {
        const code = _.get(response, 'status.code');

        if (code !== 200) {
            output.error({ error: code });
            return;
        }

        output.success({ name });
    }).catch((error) => output.error({ error }));
}

function updateOrderAmount (args, state, output, { locator, context }) {
    const API = locator.resolve('api');
    const orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
    const amount = state.get(currentOrderActions.PATHS.orderAmount);
    const amountNumber = Number(amount);
    const isDisabledAmountField = state.get(ordersComputedActions.PATHS.isDisabledAmountField);

    if (isNaN(amountNumber) || isDisabledAmountField || !amountNumber) {
        return;
    }

    const request = API.updateOrderAmount(context, locator, { amount: amountNumber, orderId });

    request.then((response) => {
        const code = _.get(response, 'status.code');

        if (code !== 200) {
            output.error({ error: code });
            return;
        }

        output.success({ amount: amountNumber });
    }).catch((error) => output.error({ error }));
}

module.exports = {
    setComputedFields (args, state) {
        computed.computeShowDownloadAllButton(state);
        computed.computeOrderCreateDate(state);
        computed.computeOrderStateName(state);
        computed.computePaymentTypeName(state);
        computed.computeOrderIsEditable(state);
        computed.computeOrderUser(state);
        computed.computeOrderManager(state);
        computed.computeDocumentsWillBeUploadedTooltipState(state);
        computed.computeNecessaryDocumentsAddDeleteButtonsState(state);
        computed.computeBillDraftDownloadButtonsState(state);
        computed.computeContinueButtonState(state);
        computed.computePayOnlineButtonState(state);
        computed.computeContinueButtonLabel(state);
        computed.computeOrderParametersIsAvailable(state);
        computed.computeIsShowIndividualOrderParameters(state);
        computed.computeIsShowResultUploadButton(state);
        computed.computeIsCanDeleteResult(state);
        computed.computeIsDisabledAmountField(state);
        computed.computeMakeOrderButtonState(state);
        computed.computeArchiveButtonState(state);
        computed.computeSaveAllButtonState(state);
        computed.computeRepeatButtonLabel(state);
        computed.computeBitrixExportButtonState(state);
        computed.computeFreeBitrixExportButtonState(state);
        computed.computeLicenseAgreementCheckboxState(state);
        computed.computeSpecialInfo(state);
        computed.computeActionPanelState(state);
        computed.computeSumCanChangeTooltipState(state);
        computed.computeManagerState(state);
        computed.computeUserState(state);
        computed.computeShowPaymentType(state);
        computed.computeManagerSelectState(state);
        computed.computeUserSelectState(state);
        computed.computeDataChangeTooltipState(state);
        computed.computeCanMoveOrderToNextState(state);
        computed.setManagerSelect(state);
        computed.setUserSelect(state);
        computed.setOrderPrice(state);
        computed.setPaymentType(state);
        computed.setUsersListFilter(state);
        computed.filterOptionsUsersList(state);
        computed.createUserButtonIsEnabled(state);
        computed.computeIsNeedToGetExportResults(state);
        computed.computeOrderStatisticState(state);
        computed.computeOrderStatisticIsLoadingState(state);
        computed.computePaymentTypeChangePanelState(state);
        computed.computeIsOnlinePaymentDisabled(state);
        computed.computeIsFilerValuesControlEnabled(state);
        computed.computeExportResultState(state);
        computed.computeIsDisabled(state);
        computed.computeDatepickerIsDisabled(state);
        computed.computeDatepicker2IsDisabled(state);
    },

    debouncedSetName,

    debouncedUpdateOrderAmount,

    /**
     * Получаем заказ пользователя
     * @param {Number} orderId
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    getOrder ({ orderId }, state, output, { locator, context }) {
        const API = locator.resolve('api');

        const request = API.getUserOrder(context, locator, { orderId });

        request.then((data) => {
            const statusCode = _.get(data, 'status.code');

            if (statusCode === 403 || statusCode === 404) {
                output.notFound();
                return;
            }

            if (statusCode !== 200) {
                output.error({ error: statusCode });
                return;
            }

            output.success({ currentOrder: data.content, availableParameters: data.content.availableParameters });
        }).catch((error) => output.error({ error }));
    },

    /**
     * Устанавливаем данные заказа в state
     * @param {Object} currentOrder
     * @param {Object} state
     */
    setCurrentOrder ({ currentOrder }, state) {
        state.set(['account', 'orders', 'currentOrder'], currentOrder);
        state.set(['order', 'price', 'data'], currentOrder.price);
        state.set(['order', 'typeId'], currentOrder.typeId);
    },

    setIsLicenseAgreementAccepted ({ isLicenseAgreementAccepted }, state) {
        state.set(['account', 'orders', 'currentOrder', 'isLicenseAgreementAccepted'], isLicenseAgreementAccepted);
    },

    setIsNeedToConfirmDataVersionChange (args, state) {
        state.set(['account', 'orders', 'currentOrder', 'isNeedToConfirmDataChanged'], true);
    },

    ifNeedToScrollTop (args, state, output) {
        const licenseMustBeAccepted = state.get(['account', 'orders', 'currentOrder', 'tooltips',
            'showLicenseMustBeAccepted']);
        const showBillDocumentMustBeAttached = state.get(currentOrderActions.PATHS.showBillDocumentMustBeAttached);
        const disableContinue = state.get(['account', 'orders', 'disableContinue']);

        if (licenseMustBeAccepted || showBillDocumentMustBeAttached || disableContinue) {
            output.no();
        } else {
            output.yes();
        }
    },

    ifOrderDataChanged ({ isDataChanged }, state, output) {
        if (isDataChanged) {
            output.yes();
        } else {
            output.no();
        }
    },

    setDataChangedConfirmed (args, state) {
        state.set(['account', 'orders', 'currentOrder', 'isNeedToConfirmDataChanged'], false);
    },

    setOrderUpdateProperty ({ path, value }, state) {
        state.set(['account', 'orders', 'currentOrder', 'update', path], value);
    },

    setPaymentTypeId ({ paymentTypeId }, state) {
        state.set(['account', 'orders', 'currentOrder', 'paymentTypeId'], paymentTypeId);
    },

    /**
     * Рассчитываем цену заказа
     * @param {Object} args
     * @param {Object} state
     */
    setOrderAmount (args, state) {
        const totalPrice = state.get(['account', 'orders', 'computed', 'price', 'data', 'total', 'totalPrice']);

        state.set(currentOrderActions.PATHS.orderAmount, totalPrice);
    },

    ifBillMustBeAttached (args, state, output) {
        const role = state.get(['user', 'role']);
        const stateId = state.get(['account', 'orders', 'currentOrder', 'stateId']);
        const necessaryDocuments = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);

        // если на "На оформлении", или "Черновик Индивидуальной выборки" то менеджер должен прикрепить счёт
        if (role == 'manager' && (stateId === 2 || stateId === 3001)) {
            const bill = _.find(necessaryDocuments, { typeId: 1 });

            if (bill && !bill.id) {
                output.yes();
            }
        }
        output.no();
    },

    /**
     * Проверка на необходимость наличия результата выборки
     * @param {Object} args
     * @param {Object} state
     * @param {Object} output
     * @returns {String}
     */
    ifExportResultMustBeAttached (args, state, output) {
        const role = state.get(['user', 'role']);
        const stateId = state.get(['account', 'orders', 'currentOrder', 'stateId']);
        const exportResults = state.get(['account', 'orders', 'currentOrder', 'exportResult']);

        // если "Черновик Индивидуальной выборки" то менеджер должен прикрепить результат выборки
        if (role === 'manager' && (stateId === 3001 || stateId === 3002) && !exportResults.length) {
            return output.yes();
        }

        return output.no();
    },

    ifUserMustBeSelected (args, state, output) {
        const typeId = state.get(['account', 'orders', 'currentOrder', 'typeId']);
        const role = state.get(['user', 'role']);
        const isUserSelected = state.get(['account', 'orders', 'computed', 'selectedUser', 'isUserSelected']);

        if ((typeId === 1 || typeId === 4) && role === 'manager' && isUserSelected === false) {
            output.yes();
        }

        output.no();
    },

    ifPriceMustBeBiggerThenZero (args, state, output) {
        const orderTotalPrice = state.get(['account', 'orders', 'currentOrder', 'price', 'total', 'totalPrice']);
        const orderAmount = state.get(currentOrderActions.PATHS.orderAmount);
        const typeId = state.get(['account', 'orders', 'currentOrder', 'typeId']);
        const orderPrice = typeId === 4 ? Number(orderAmount) : orderTotalPrice;

        if (isNaN(orderPrice) || orderPrice <= 0) {
            output.yes();
        }

        output.no();
    },

    ifLicenseMustBeAccepted (args, state, output) {
        const userMustAcceptLicense = state.get(['account', 'orders', 'computed', 'componentsState',
            'showLicenseAgreementCheckbox']);
        const userAcceptLicenseAgreement = state.get(['account', 'orders', 'currentOrder', 'update',
            'userAcceptLicenseAgreement']);

        if (userMustAcceptLicense && !userAcceptLicenseAgreement) {
            output.yes();
        }

        output.no();
    },

    ifAcceptLicenseAgreement (args, state, output) {
        const userAcceptLicenseAgreement = state.get(['account', 'orders', 'currentOrder', 'update',
            'userAcceptLicenseAgreement']);

        if (userAcceptLicenseAgreement) {
            output.yes();
        }

        output.no();
    },

    ifCanMoverOrderToNextState (args, state, output) {
        if (state.get(['account', 'orders', 'computed', 'сanMoveOrderToNextState'])) {
            output.yes();
        } else {
            output.no();
        }
    },

    ifContinueDisabled (args, state, output) {
        if (state.get(['account', 'orders', 'disableContinue'])) {
            output.yes();
        } else {
            output.no();
        }
    },

    /**
     * Пользователь принимает лицензионное соглашение
     * @param {Object} args
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    acceptLicenseAgreement (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let request = API.acceptLicenseAgreement(context, locator, { orderId });
        thenWithErrorHandling(
            request,
            () => ({ isLicenseAgreementAccepted: true }),
            output);
    },

    ifAcceptDataChanged (args, state, output) {
        let isNeedToConfirmDataChanged = state.get(['account', 'orders', 'currentOrder',
            'isNeedToConfirmDataChanged']);

        if (isNeedToConfirmDataChanged) {
            output.yes();
        }
        output.no();
    },

    /**
     * Пользователь/менеджер подтверждает согласие с тем, что данные заказа изменились и он не против
     * @param {Object} args
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    confirmDataChanged (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let request = API.confirmDataChanged(context, locator, { orderId });
        thenWithErrorHandling(
            request,
            () => ({}),
            output);
    },

    /**
     * Перевести заказ в следующее состояние
     * @param {String} args
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    moveOrderToNextState (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);

        let request = API.moveOrderToNextState(context, locator, { orderId });

        request.then((data) => {
            let status = _.get(data, 'status.code');
            if (status === 503) {
                output.temporarilyUnavailable();
                return;
            }
            if (status !== 200 && status !== 503) {
                output.error({ error: status });
                return;
            }
            output.success({ stateId: _.get(data, 'content.stateId'),
                exportResult: _.get(data, 'content.exportResult'),
                isDataChanged: _.get(data, 'content.isNeedToConfirmDataChanged'),
                availableParameters: _.get(data, 'content.availableParameters'),
                selectedParameters: _.get(data, 'content.selectedParameters'),
                necessaryDocuments: _.get(data, 'content.necessaryDocuments'),
                paymentForm: _.get(data, 'content.paymentForm'),
                price: _.get(data, 'content.price')
            });
        }).catch((error) => output.error({ error }));
    },

    /**
     * Перевести заказ в архив
     * @param {String} args
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    archiveOrder (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);

        let request = API.archiveOrder(context, locator, { orderId });
        thenWithErrorHandling(
            request,
            (data) => ({ stateId: _.get(data, 'content.stateId'), stateName: _.get(data, 'content.stateName') }),
            output);
    },

    isDownloadingExportResult ({ fileId }, state, output) {
        let exportResult = state.get(['account', 'orders', 'currentOrder', 'exportResult']);
        if (exportResult && exportResult.id == fileId) {
            output.yes();
        }
    },

    /**
     * Скачать файл
     * @param {Number} fileId
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    downloadFile ({ fileId }, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let exportResults = state.get(['account', 'orders', 'currentOrder', 'exportResult']);
        let fileName = '';
        let isExportResult = false;

        // файл может быть результатом экспорта или документом
        let exportResult = _.find(exportResults, { id: fileId.toString() });
        if (exportResult) {
            fileName = exportResult.name;
            isExportResult = true;
        } else {
            let documents = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
            fileName = _.find(documents, { id: fileId.toString() }).name;
        }

        let request = API.downloadFile(context, locator, { fileId, fileName });
        request.then((response) => {
            if (response.code === 200) {
                var blob = new Blob([response.content], { type: response.contentType });
                saveAs(blob, fileName);
                if (isExportResult) {
                    output.exportResultDownloaded();
                }
            } else {
                output.error({ error: response.code });
            }
        }).catch((error) => output.error({ error }));
    },

    /**
     * Скачать всё
     * @param {Object} args
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    downloadAll (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let exportResults = state.get(['account', 'orders', 'currentOrder', 'exportResult']);

        let i = 0;
        let onProgressHandler = function (oEvent) {
            if (oEvent.lengthComputable) {
                progressBarHelper.setPercentage('download-all', (oEvent.loaded / oEvent.total) * 100);
            } else {
                // Невозможно вычислить состояние загрузки, так как размер неизвестен
            }
        };
        let onStartDownload = (fileName) => {
            progressBarHelper.init('download-all', fileName);
        };
        downloadAllInternal(exportResults, i, context, locator, API, output, onProgressHandler, onStartDownload);
    },

    downloadDraftFile ({ orderId, typeId }, state, output, { locator, context }) {
        let API = locator.resolve('api');

        let request = API.downloadDraftFile(context, locator, { orderId, typeId });
        request.then((response) => {
            if (response.code === 200) {
                var blob = new Blob([response.content], { type: response.contentType });
                var fileName = response.contentDisposition.match(/attachment; filename=(.+)/)[1];
                saveAs(blob, fileName);
                output.ok();
            } else {
                output.error({ error: response.code });
            }
        }).catch((error) => output.error({ error }));
    },

    /**
     * Получаем список пользователей
     * @param {Object} args
     * @param {Object} state
     * @param {Object} output
     * @param {Object} service.locator
     * @param {Object} service.context
     */
    getUsers (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let request = API.getUsers(context, locator);

        thenWithErrorHandling(
            request,
            (data) => ({ users: _.get(data, 'content') }),
            output);
    },

    /**
     * Получаем список менеджеров
     * @param {Object} args
     * @param {Object} state
     * @param {Object} output
     * @param {Object} service.locator
     * @param {Object} service.context
     */
    getManagers (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let request = API.getManagers(context, locator);

        thenWithErrorHandling(
            request,
            (data) => ({ managers: _.get(data, 'content') }),
            output);
    },

    setPaymentTypeId (args, state) {
        state.set(['account', 'orders', 'currentOrder', 'paymentTypeId'],
            state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId']));
    },

    selectPaymentType ({ key }, state) {
        const path = ['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId'];

        const paymentMap = {
            invoice: 1,
            online: 2
        };

        state.set(path, paymentMap[key]);
    },

    initOrderType ({ key }, state) {
        let orderType = {
            1: true,
            2: false,
            3: false,
            4: false
        };
        state.set(['account', 'orders', 'create', 'orderType'], orderType);
    },

    selectOrderType ({ key }, state) {
        let orderType = state.get(['account', 'orders', 'create', 'orderType']);
        for(let property in orderType) {
            state.set(['account', 'orders', 'create', 'orderType', property], false);
        }
        state.set(['account', 'orders', 'create', 'orderType', key], true);
    },

    fillOrderTypeInSelectedParameters (args) {
        args.selectedParameters = { orderType: Number(args.selectedValue) };
    },

    /**
     * Небольшой костыль. При локальной смене способа оплаты делаем документ типа "Счёт-оферта" обязательным/необязательным
     * @param {Object} args
     * @param {Object} state
     */
    toggleBillDocumentIsCheckable (args, state) {
        let docs = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
        let billIndex = _.findIndex(docs, { 'typeId': 1 });
        if (billIndex > -1) {
            let value = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments', billIndex, 'isCheckable']);
            state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', billIndex, 'isCheckable'], !value);
            args.path = billIndex;
            args.value = value;
        }
    },

    isPaymentTypeChanged (args, state, output) {
        let paymentId = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId']);
        if (paymentId) {
            output.true();
            return;
        }
        output.false();
    },

    setPaymentType (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let paymentId = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId']);

        let request = API.setPaymentType(context, locator, { paymentId, orderId });

        request.then((response) => {
            let code = _.get(response, 'status.code');
            if (code !== 200) {
                output.error({ error: code });
                return;
            }

            let paymentTypeId = _.get(response, 'content.paymentTypeId');
            let necessaryDocuments = _.get(response, 'content.necessaryDocuments');
            output.success({ paymentTypeId, necessaryDocuments });
        })
            .catch((error) => output.error({ error }));
    },

    selectUser ({ selectedValue }, state) {
        const id = Number(selectedValue);
        const users = state.get(['account', 'orders', 'users']);

        const user = _.find(users, { id });

        state.set(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser'], user);
    },

    createUserStub (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let email = state.get(['account', 'orders', 'createUser', 'input', 'email']);
        let registerData = { email };

        let request = API.registerStubHermesUser(context, locator, { registerData });

        thenWithErrorHandling(
            request,
            (data) => ({ user: _.get(data, 'content') }),
            output);
    },

    selectManager ({ selectedValue }, state) {
        let id = Number(selectedValue);
        let managers = state.get(['account', 'orders', 'managers']);

        let manager = _.find(managers, { id });

        state.set(['account', 'orders', 'currentOrder', 'localChanges', 'selectedManager'], manager);
    },

    resetUserSelect (args, state) {
        state.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser', 'id']);
    },

    setUser (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);

        let orderUserId = state.get(['account', 'orders', 'currentOrder', 'user', 'id']);
        let selectedUserId = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser', 'id']);
        let userId = selectedUserId || orderUserId;

        let request = API.setUser(context, locator, { userId, orderId });

        thenWithErrorHandling(
            request,
            (data) => ({ user: _.get(data, 'content.user'),
                necessaryDocuments: _.get(data, 'content.necessaryDocuments') }),
            output);
    },

    resetManagerSelect (args, state) {
        state.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedManager', 'id']);
    },

    resetAddParams (args, state) {
        state.unset(['order', 'addParams']);
    },

    setManager (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);

        let orderManagerId = state.get(['account', 'orders', 'currentOrder', 'manager', 'id']);
        let selectedManagerId = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedManager', 'id']);
        let managerId = selectedManagerId || orderManagerId;

        let request = API.setManager(context, locator, { managerId, orderId });

        thenWithErrorHandling(
            request,
            (data) => ({ manager: _.get(data, 'content.manager')}),
            output);
    },

    payOnline (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let request = API.getOnlinePaymentForm(context, locator, { orderId });
        thenWithErrorHandling(
            request,
            (data) => ({ url: _.get(data, 'content.url'), data: _.get(data, 'content.data') }),
            output);
    },

    setOrderPaymentForm ({ url, data }, state) {
        state.set(['account', 'orders', 'currentOrder', 'paymentForm'], { url, data });
    },

    isManagerChanged (args, state, output) {
        let manager = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedManager']);
        if (manager) {
            output.true();
        } else {
            output.false();
        }
    },

    /**
     * Проверяем были ли применены все локальные изменения
     * @param {Object} args
     * @param {Object} state
     * @param {Object} output
     */
    unsetLocalChangesIfEmpty (args, state, output) {
        let localChanges = state.get(['account', 'orders', 'currentOrder', 'localChanges']);
        if (localChanges) {
            if (Object.keys(localChanges).length === 0) {
                state.unset(['account', 'orders', 'currentOrder', 'localChanges']);
            }
            if (Object.keys(localChanges).length === 1 && localChanges.necessaryDocuments) {
                if (Object.keys(localChanges.necessaryDocuments).length === 0) {
                    state.unset(['account', 'orders', 'currentOrder', 'localChanges']);
                }
            }
        }
    },

    saveLocalChanges (args, state, output, { locator, context }) {
        if (context.isServer) {
            return;
        }
        let window = locator.resolve('window');

        let localChanges = state.get(['account', 'orders', 'currentOrder', 'localChanges']);
        window.localStorage.setItem('local_draft', JSON.stringify(localChanges));
    },

    restoreLocalChanges ({ selectedParameters }, state, output, { context, locator }) {
        if (context.isServer) {
            return;
        }
        let window = locator.resolve('window');
        let serialized = window.localStorage.getItem('local_draft');

        if (!serialized) {
            return;
        }

        let localChanges = null;
        try {
            localChanges = JSON.parse(serialized);
        } catch (e) {
            return;
        }

        output({ localChanges });
    },

    removeLocalChanges (args, state, output, { context, locator }) {
        if (context.isServer) {
            return;
        }

        let window = locator.resolve('window');
        window.localStorage.removeItem('local_draft');
    },

    initAccountState ({ localChanges }, state, output, { locator, context }) {
        state.set(['account', 'orders', 'list', 'data', 0, 'id'], "1");
        state.set(['account', 'orders', 'list', 'data', 0, 'createDate'], Date.now());
        state.set(['account', 'orders', 'list', 'data', 0, 'stateId'], 1000);

        state.set(['account', 'orders', 'currentOrder', 'id'], "1");
        state.set(['account', 'orders', 'currentOrder', 'typeId'], 1);
        state.set(['account', 'orders', 'currentOrder', 'stateId'], 1000);
        state.set(['account', 'orders', 'currentOrder', 'manager'], null);

        if (context.isServer) {
            return;
        }

        let window = locator.resolve('window');

        if (window.localStorage.getItem('local_draft') === null) {
            let localChanges = {
                selectedPaymentTypeId: 2,
                necessaryDocuments: {
                    addOrRemove: []
                }
            };
            window.localStorage.setItem('local_draft', JSON.stringify(localChanges));
        }
    },

    restoreAccountOrderState ({ localChanges }, state) {
        if (localChanges) {
            state.set(['account', 'orders', 'currentOrder', 'localChanges'], localChanges);
            let docTypes = _.get(localChanges, 'necessaryDocuments.addOrRemove', []);
            let orderDocs = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
            _.forEach(docTypes, function (docType) {
                if (docType.value) {
                    let orderDocIndex = _.findIndex(orderDocs, { typeId: docType.documentTypeId });
                    state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', orderDocIndex, 'isChecked'], true);
                }
            });
        }
    },

    saveLocalChangesFilterValues (args, state, output) {
        state.set(['account', 'orders', 'currentOrder', 'localChanges', 'filterValuesChanged'], true);
        output({ price: state.get(['order', 'price', 'data']) });
    },

    isFilterValuesChanged (args, state, output) {
        let filterValuesChanged = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'filterValuesChanged']);
        if (filterValuesChanged && filterValuesChanged === true) {
            output.true();
        } else {
            output.false();
        }
    },

    isFilterValuesInEditMode (args, state, output) {
        let isDisabled = state.get(['order', 'isDisabled']);
        if (isDisabled === false) {
            output.yes();
        } else {
            output.no();
        }
    },

    orderIdToArgs (args, state) {
        args.orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
    },

    repeatOrder (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);

        let request = API.repeatOrder(context, locator, { orderId });
        request.then((response) => {
            let code = _.get(response, 'status.code');
            if (code !== 201) {
                output.error({ error: code });
                return;
            }
            output.success({ orderId: _.get(response, 'content.id') });
        })
        .catch((error) => output.error({ error }));
    },

    initOrderCreatorSelect (args, state) {
        state.set(['account', 'orders', 'createOrder', 'options'],
            [{ isActive: false, title: 'Online выборка', value: 1 },
            { isActive: false, title: 'Offline выборка', value: 2 },
            { isActive: false, title: 'Offline адр. план', value: 3 },
            { isActive: false, title: 'Индив. выборка', value: 4 }]);
        state.set(['account', 'orders', 'createOrder', 'isDisable'], false);
        state.set(['account', 'orders', 'createOrder', 'header'], 'Новый заказ');
    },

    validateOrderId ({ orderId = '' }, state, output) {
        const orderNumberId = orderId.replace('DATA', '');
        output({ orderId: orderNumberId });
    }
};

function downloadAllInternal (exportResults, i, context, locator, API, output, onProgressHandler, onStartDownload) {
    let fileName = exportResults[i].name;
    let request = API.downloadFile(context, locator, { fileId: exportResults[i].id, fileName }, onProgressHandler);
    onStartDownload(fileName);
    request.then((response) => {
        if (response.code === 200) {
            let blob = new Blob([response.content], { type: response.contentType });
            saveAs(blob, fileName);
            i++;
            if (i < exportResults.length) {
                downloadAllInternal(exportResults, i, context, locator, API, output, onProgressHandler, onStartDownload);
            } else {
                output.success();
            }
        } else {
            output.error({ error: response.code });
        }
    }).catch((error) => output.error({ error }));
}



// WEBPACK FOOTER //
// ./actions/account/orders.js